// Team colors matching POC design
export const TEAMS = {
  payments: "#2196F3",  // Blue
  checkout: "#4CAF50",  // Green
  billing: "#FF9800",   // Orange
  growth: "#9C27B0",    // Purple
  platform: "#607D8B",  // Gray
  core: "#6366f1",      // Indigo
}

export function getTeamColor(team) {
  return team && TEAMS[team] ? TEAMS[team] : null
}
